<div>
  <app-breadcrumb
    [breadcrumbItems]="{
      currentPageLink: '/privacy-policy',
      currentPage: 'Privacy Policy'
    }"
  />

  <div class="custom-container">
    <p class="section-title mt-40">Privacy Policy</p>
  
    <app-terms-content [termsData]="privacyPolicy" />
  </div>
</div>